import React from 'react';

const AppContext = React.createContext();

export {AppContext as default};